<template>
  <base-section
    id="info-alt"
    space="56"
  >
    <v-container>
      <v-row justify="space-between">
        <v-col
          cols="12"
          md="5"
        >
          <base-business-info title="MANTENTE EN CONTACTO CON NOSOTROS">
            Si deseas información sobre algún artículo puedes comunicarte al +56 9 6741 5474 o si deseas una cotización puedes enviarnos tu solicitud al correo.
          </base-business-info>
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <base-contact-form title="ENVÍENOS SU MENSAJE" />
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionKeepInTouch',
  }
</script>
